import { Icon } from '@/new/components/icon';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/new/components/shadcn/accordion';
import { Skeleton } from '@/new/components/shadcn/skeleton';
import { TextWithReferences } from '@/new/components/text-references';

interface CaseSummarySectionProps {
  summaryText: string;
  isDeletedDocRunOngoing: boolean;
  isLoading?: boolean;
}

export const Summary = ({
  summaryText,
  isDeletedDocRunOngoing = false,
  isLoading = false,
}: CaseSummarySectionProps) => {
  return (
    <>
      <div>
        {isLoading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-full bg-gray-200" />
            <Skeleton className="h-4 w-5/6 bg-gray-200" />
            <Skeleton className="h-4 w-4/5 bg-gray-200" />
          </div>
        ) : isDeletedDocRunOngoing ? (
          <div className="flex h-full flex-col items-center justify-center gap-2">
            <Icon className="lucide--loader-circle h-6 w-6 animate-spin text-gray-500" />
            <div className="text-sm text-gray-600">The summary is currently being updated.</div>
          </div>
        ) : summaryText ? (
          <div className="space-y-4">
            <div className="w-full rounded-md border">
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="summary" className="border-none">
                  <AccordionTrigger className="rounded-t-md bg-gray-50 px-4 py-2 hover:bg-gray-100 hover:no-underline">
                    <div className="flex items-center gap-3">
                      <span className="font-medium text-gray-700">View Summary</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 py-4">
                    <div className="prose prose-sm max-w-none leading-relaxed text-gray-700">
                      <TextWithReferences content={summaryText} />
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-gray-400">No summary available</div>
        )}
      </div>
    </>
  );
};
